// extracted by mini-css-extract-plugin
module.exports = {"logoaskew":"labels_logoaskew__dbHlj","unskew":"labels_unskew__32mlv","shakyshaky":"labels_shakyshaky__3uojR","shake":"labels_shake__3KpUj"};